/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Sara API
 * Sara AI Video Interviewer API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  SetUserSuperAdminDto,
  UserSuperAdminDto
} from '../model';

import { customFetch } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getSetUserSuperAdminUrl = (id: string,) => {




  return `/users/${id}/super-admin`
}

export const setUserSuperAdmin = async (id: string,
    setUserSuperAdminDto: SetUserSuperAdminDto, options?: Parameters<typeof customFetch>[1]): Promise<UserSuperAdminDto> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<UserSuperAdminDto>(getSetUserSuperAdminUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setUserSuperAdminDto)
  }
);}





export const getSetUserSuperAdminMutationKey = () => ['setUserSuperAdmin'] as const;

export const getSetUserSuperAdminMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserSuperAdmin>>, TError,SetUserSuperAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserSuperAdmin>>, TError,SetUserSuperAdminMutationVariables, TContext> => {

const mutationKey = getSetUserSuperAdminMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserSuperAdmin>>, SetUserSuperAdminMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  setUserSuperAdmin(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetUserSuperAdminMutationResult = NonNullable<Awaited<ReturnType<typeof setUserSuperAdmin>>>
    export type SetUserSuperAdminMutationBody = SetUserSuperAdminDto
    export type SetUserSuperAdminMutationError = unknown
    export type SetUserSuperAdminMutationVariables = {id: string;data: SetUserSuperAdminDto}

    export const useSetUserSuperAdmin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserSuperAdmin>>, TError,SetUserSuperAdminMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setUserSuperAdmin>>,
        TError,
        SetUserSuperAdminMutationVariables,
        TContext
      > => {
      return useMutation(getSetUserSuperAdminMutationOptions(options), queryClient);
    }
